// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "categories-landing-" + (chunkId === 226 ? "webfooter-Footer" : chunkId) + "-st-" + {"41":"30ee42b6","213":"e937f22d","226":"2fcae59c","461":"70993508","518":"8b90b5cf","722":"8e3f193a","846":"602a5381"}[chunkId] + ".js";
};